import * as React from 'react';
import { LegalHeadBg, LegalBanner } from '../../components/UI/LegalUI';

const LegalHead: React.SFC = ({ children }) => (
  <LegalHeadBg>
    {children}
    <LegalBanner>Legal</LegalBanner>
  </LegalHeadBg>
);

export default LegalHead;



// WEBPACK FOOTER //
// ./src/containers/Site/LegalHead.tsx